import NotificationsContainer from '@rio-cloud/rio-uikit/NotificationsContainer';
import ApplicationLayout from 'components/ApplicationLayout';
import AppHeader from 'features/header/AppHeader';
import SystemHealthNotification from 'features/system-health/SystemHealthNotification';
import { useCheckHealthStatus } from 'hooks/useCheckHealthStatus';
import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';
import { DEFAULT_LOCALE } from 'store/i18n/lang';
import { getDisplayMessages, getLocale } from 'store/i18n/langSlice';
import { useAppSelector } from 'store/setup/hooks';
import { getSystemStatus } from 'store/slices/healthStatusSlice';

import setHeaderTitle from './utils';

const AppLayout = () => {
    const userLocale = useAppSelector(getLocale);
    const displayMessages = useAppSelector(getDisplayMessages);
    const { pathname } = useLocation();
    const isSystemOk = useSelector(getSystemStatus);
    useCheckHealthStatus();
    const title = setHeaderTitle(pathname);

    if (!displayMessages || !userLocale) {
        return null;
    }

    const isMonitoringPage = pathname === '/';

    /*
    TODO: move this logic outta this components from the moment we add multiple pages
    const title = isMonitoringPage ? (
      <FormattedMessage id={'intl-msg:control-center.sublink.monitoring'} />
    ) : (
      <FormattedMessage id={'intl-msg:control-center.sublink.vehicle'} />
    )
  */

    return (
        <IntlProvider defaultLocale={DEFAULT_LOCALE} key={userLocale} locale={userLocale} messages={displayMessages}>
            <ApplicationLayout>
                <ApplicationLayout.Header>
                    <AppHeader title={title} showAccountMenu={isMonitoringPage} />
                    {!isSystemOk && (
                        <div className='AppLayout__header'>
                            <SystemHealthNotification shouldRender={isSystemOk} />
                        </div>
                    )}
                </ApplicationLayout.Header>
                {/* UIKit class padding-0 needed for internal css selectors to work */}
                <ApplicationLayout.Body
                    forceScrollbar={false}
                    enableScrollToTop={false}
                    className='AppLayout__body'
                    innerClassName={`p-0 padding-0 ${!isSystemOk && 'mt-45px'}`}
                >
                    <NotificationsContainer />
                    <div className={`${!isSystemOk ? 'h-calc-100vh-95px' : 'h-full'}`}>
                        <Outlet />
                    </div>
                </ApplicationLayout.Body>
            </ApplicationLayout>
        </IntlProvider>
    );
};

export default AppLayout;
